export var ProspectStatuses;
(function (ProspectStatuses) {
    ProspectStatuses["ALL"] = "All";
    ProspectStatuses["IDENTIFIED"] = "Identified";
    ProspectStatuses["APPLIED"] = "Applied";
})(ProspectStatuses || (ProspectStatuses = {}));
